import { Injectable } from '@angular/core';
import {AuthHttp} from '../../user/services/auth/http/auth-http.service';
import {environment} from '../../../../environments/environment';

export interface BillingReportFilters {
  airports: number[] | null;
  airlines: number[] | null;
  startDate: Date | null;
  endDate: Date | null;
}

@Injectable()
export class BillingReportService {

  private route = 'billing-report';

  constructor(private http: AuthHttp) {}

  public runReport(filters: BillingReportFilters) {
    return this.http.post(`${environment.baseUrl}${this.route}/run-report`,
      {filters: filters}, {throwError: true}).map(r => r.text())
      .do((name) =>
        window.location.href =
          encodeURI(`${environment.baseUrl}${this.route}/get-report?token=${this.http.getTokenBearer()}&file=${name}`)
      )
      .toPromise();
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/billing-report/services/billing-report.service.ts